<template>
  <div class="BlockTitle">
    <h2 class="BlockTitle-title">{{ title }}</h2>
    <button v-if="canEdit" class="BlockTitle-button" @click="openModal">
      <i class="material-icons">edit</i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BlockTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    modalToEdit: {
      type: String,
      default: null
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openModal() {
      this.$router.push({query: {modal: this.modalToEdit}})
    }
  }
}
</script>

<style>
.BlockTitle {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  &-title {
    text-transform: uppercase;
    font-size: 14px;
    color: #171717;
  }
  &-button {
    margin-left: 10px !important;
    &:hover {
      color: #969696;
    }
    i {
      font-size: 16px;
    }
  }
}
</style>
